export async function registerServiceWorker(): Promise<ServiceWorkerRegistration | null> {
  if (!("serviceWorker" in navigator)) {
    console.warn("[SW] 서비스워커 미지원 환경 (HTTP IP 접근 등). SW 기능 비활성화.");
    return null;
  }

  try {
    const reg = await navigator.serviceWorker.register("/sw.js", {
      scope: "/",
    });
    console.log("[SW] 등록 완료:", reg.scope);

    // 폴링이 멈췄다가 watchdog으로 되살아난 경우 원인을 페이지 콘솔에 남김
    navigator.serviceWorker.addEventListener("message", (e) => {
      if (e.data?.type === "POLL_RESTARTED") console.warn("[SW] 폴링 멈춤 감지 → 자동 복구", e.data);
    });

    // 알림 권한 요청 (등록 시점에 한 번)
    if ("Notification" in window && Notification.permission === "default") {
      await Notification.requestPermission();
    }

    return reg;
  } catch (err) {
    console.error("[SW] 등록 실패:", err);
    return null;
  }
}

// SW에 메시지 전송 헬퍼
function sendToSW(message: object) {
  if (!("serviceWorker" in navigator)) return;
  const sw = navigator.serviceWorker.controller;
  if (!sw) {
    console.warn("[SW] 활성 서비스워커 없음");
    return;
  }
  sw.postMessage(message);
}

export const swBridge = {
  // watchdog=true: 주기적 kick. SW가 살아있으면 no-op, 멈춰있었으면 재시작 + 원인 통지
  startPolling(uuid: string, baseUrl: string, watchdog = false) {
    sendToSW({ type: "START_POLLING", uuid, baseUrl, watchdog });
  },

  stopPolling(uuid: string) {
    sendToSW({ type: "STOP_POLLING", uuid });
  },

  clearCache(uuid: string) {
    sendToSW({ type: "CLEAR_CACHE", uuid });
  },

  notify({ title, body, url }: { title: string; body: string; url: string }) {
    sendToSW({ type: "TRAINING_COMPLETE", payload: { title, body, url } });
  },
};
